var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedNoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM9 16.2C5.022 16.2 1.8 12.978 1.8 9C1.8 7.335 2.367 5.805 3.321 4.59L13.41 14.679C12.195 15.633 10.665 16.2 9 16.2ZM14.679 13.41L4.59 3.321C5.805 2.367 7.335 1.8 9 1.8C12.978 1.8 16.2 5.022 16.2 9C16.2 10.665 15.633 12.195 14.679 13.41Z",
    fill: "#C1C1C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedNoIcon);
export default __webpack_public_path__ + "static/media/DeprecatedNoIcon.ff1fbf79903b4ea7ae47dba84085cfbf.svg";
export { ForwardRef as ReactComponent };